var map = {
	"./brew-on-quay-colored.png": 6077,
	"./brew-on-quay.png": 6176,
	"./cafe-runddelen-colored.png": 8934,
	"./cafe-runddelen.png": 743,
	"./fagans-colored.png": 2236,
	"./fagans.png": 968,
	"./flying-barrel-colored.png": 8924,
	"./flying-barrel.png": 911,
	"./fr-vi-colored.png": 4270,
	"./fr-vi.png": 8116,
	"./freddys-bar-colored.png": 7180,
	"./freddys-bar.png": 4167,
	"./globe-colored.png": 9763,
	"./globe.png": 7114,
	"./good-spirits-hospitality-colored.png": 9576,
	"./good-spirits-hospitality.png": 1850,
	"./interpool-colored.png": 47,
	"./interpool.png": 28,
	"./johns-colored.png": 1272,
	"./johns.png": 1430,
	"./malmo-sportbar-colored.png": 19,
	"./malmo-sportbar.png": 6142,
	"./proud-mary-pub-colored.png": 3143,
	"./proud-mary-pub.png": 919,
	"./pubsport-colored.png": 1696,
	"./pubsport-half-padding.png": 1483,
	"./pubsport.png": 5683,
	"./rekom-colored.png": 164,
	"./rekom.png": 3578,
	"./shamrock-colored.png": 2272,
	"./shamrock.png": 3054,
	"./the-cav-colored.png": 3576,
	"./the-cav.png": 6325,
	"./the-fox-colored.png": 1932,
	"./the-fox.png": 4597,
	"./the-kingslander-colored.png": 9044,
	"./the-kingslander.png": 9690
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9079;